import Component from '../core/Component'
import EventBus from '../core/EventBus'
import CourseState from '../meta/CourseState'
import { toggleClass } from '../utils/dom'
import { createModal } from './Modal'
import scrollToElement from '../services/Viewport/scrollToElement'
import enquire from 'enquire.js'
import { queries, lang } from '../core/config'

export const STATES = {
    COMPLETED: 'is-completed'
}

export default class CourseCard extends Component {
    constructor(element) {
        super(element)
        this.id = this.element.dataset.id
        this.chatUrl = this.element.dataset.chatUrl

        this.ref = {
            openButtons: [],
            toggle: null,
            content: null
        }

        this.isChatResolved = false
        this.isMobile = false

        this.enquireHandler = {
            match: () => {
                this.isMobile = true
            },
            unmatch: () => {
                this.isMobile = false
            }
        }
    }

    prepare() {
        this.ref.toggle.addEventListener('click', this.handleToggleClick)
        this.ref.openButtons.forEach(button => button.addEventListener('click', this.handleOpenClick))
        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state.lessons[this.id] || {})
        EventBus.on('chat:resolved', this.handleChatResolved)
        EventBus.on('modal:close', this.handleModalClose)

        enquire.register(queries.smallWideMax, this.enquireHandler)

        const fragment = window.location.hash.replace('#', '')
        if (fragment === this.element.id.replace('accordion-', '') && CourseState.state.lessons[this.id].completed) {
            const accordion = Component.getFromElement(this.element.closest('[data-component="Accordion"]'))

            if (accordion) {
                setTimeout(() => {
                    const index = accordion.ref.items.indexOf(this.element)
                    accordion.open(index, true)
                    accordion.scrollToView(index, true)
                }, 0)
            }
        }
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    handleStateChange = state => {
        this.render(state.lessons[this.id] || {})
    }

    handleOpenClick = event => {
        event.preventDefault()

        EventBus.emit('chat:open', {
            id: this.id
        })

        this.openChat()
    }

    handleToggleClick = event => {
        const completed = (CourseState.state.lessons[this.id] || {}).completed

        if (completed) {
            return
        }

        event.preventDefault()
        EventBus.emit('chat:open', {
            id: this.id
        })

        this.openChat()
    }

    handleChatResolved = ({ answers, id }) => {
        if (this.id !== id) {
            return
        }

        const correctCount = answers
            .filter(answer => answer.correct)
            .length

        const stars = Math.max(Math.min(correctCount, 3), 0)

        CourseState.updateLesson({
            id: this.id,
            stars,
            completed: true
        })

        if (CourseState.hasAllStars) {
            EventBus.emit('course:finished')

            return
        }

        this.isChatResolved = true

        const accordion = Component.getFromElement(this.element.closest('[data-component="Accordion"]'))

        if (accordion) {
            setTimeout(() => {
                const index = accordion.ref.items.indexOf(this.element)
                accordion
                    .open(index, true)
                    .then(() => {
                        scrollToElement(this.isMobile ? this.ref.content : this.element, 20)
                    })
            }, 0)
        }
    }

    handleModalClose = ({ options }) => {
        if (options?.chatId !== this.id) {
            return
        }

        if (CourseState.isCompleted) {
            return
        }

        setTimeout(() => {
            if (!this.isChatResolved) {
                const offset = document.querySelector('.header')?.getBoundingClientRect()?.height
                scrollToElement(this.element, (offset + 20) || 80)
            }
        }, 0)
    }

    render({ stars = 0, completed = false }) {
        toggleClass(this.element, STATES.COMPLETED, completed)
        toggleClass(this.element, 'has-stars-0', stars === 0)
        toggleClass(this.element, 'has-stars-1', stars === 1)
        toggleClass(this.element, 'has-stars-2', stars === 2)
        toggleClass(this.element, 'has-stars-3', stars === 3)
        this.element.dataset.disabled = completed ? '' : '1'
    }

    openChat() {
        createModal({
            url: this.chatUrl,
            autoOpen: true,
            className: 'chat-Modal',
            chatId: this.id,
            filterResponse: html => {
                const buffer = document.createElement('div')
                buffer.innerHTML = html
                const content = buffer.querySelector('[data-modal-content]')
                return content.innerHTML
            }
        })
    }

}